/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { EditorCellModel } from "./EditorCellModel";
import { Rect } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(EditorCellPresenter, _super);
    function EditorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(EditorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: false,
        configurable: true
    });
    EditorCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (b.ay) {
            if (b.a3(EditorCellModel.l1) || b.a3(EditorCellModel.lz) || b.a3(EditorCellModel.l0) || b.a3(EditorCellModel.l2)) {
                this.d.cm = b.lq;
                this.d.df = b.ma;
                this.d.dk = b.mj;
                this.d.ci = b.lk;
            }
            if (b.a3(EditorCellModel.lx)) {
                this.d.ck = b.lm;
            }
            if (b.a3(EditorCellModel.f0)) {
                this.d.dg = b.g3;
            }
            if (b.a3(EditorCellModel.l3)) {
                this.d.d9(b.lo == null);
            }
            if (b.a3(CellModel.fa)) {
                this.d.cz = b.ag;
            }
            if (b.a3(EditorCellModel.l4)) {
                if (stringIsNullOrWhiteSpace(b.mo)) {
                    this.d.c5 = false;
                    this.d.dx();
                }
                else {
                    this.d.c5 = true;
                    this.d.ed(b.mo, b.cl, b.cm, b.gu, b.fc);
                }
            }
            if (b.a3(EditorCellModel.er)) {
                this.d.c9 = Rect.l_op_Equality(b.li, Rect.empty) ? false : true;
            }
            if (b.a3(EditorCellModel.ly)) {
                this.d.dp = b.mg;
            }
        }
        if (b.a3(EditorCellModel.l5)) {
            this.d.be();
        }
    };
    EditorCellPresenter.$t = markType(EditorCellPresenter, 'EditorCellPresenter', CellPresenterBase.$);
    return EditorCellPresenter;
}(CellPresenterBase));
export { EditorCellPresenter };
//# sourceMappingURL=EditorCellPresenter.js.map
